<template>
  <MenusContainer showBar :menus="menus" />
</template>

<script>
import MenusContainer from "@/components/MenusContainer";
export default {
  components: {
    MenusContainer,
  },
  data() {
    return {
      menus: [
        {
          title: "我的待办",
          path: "/task/todo-task-list",
        },
        {
          title: "我的待阅",
          path: "/task/todo-read-list",
          active: true,
        },
        {
          title: "我的已办",
          path: "/task/done-task-list",
        },
        {
          title: "我的已阅",
          path: "/task/history-read-list",
        },
        {
          title: "我的草稿",
          path: "/task/draft-task-list",
        },
        {
          title: "我的创建",
          path: "/task/create-task-list",
        },
        {
          title: "所有流程",
          path: "/task/all-task-list",
        },
      ],
    };
  },
  created() {
    // const { tab } = this.$route.query;
  },
};
</script>

<style></style>
